import { useCallback, useEffect, useRef, useState } from 'react';

export const useStickyElement = (topPosition: number) => {
    const stickyElementRef = useRef<HTMLDivElement>(null);

    const [isSticky, setIsSticky] = useState(false);

    const checkStickiness = useCallback(() => {
        if (!stickyElementRef.current) return;
        const rect = stickyElementRef.current.getBoundingClientRect();
        if (rect.top <= topPosition) setIsSticky(true);
        else setIsSticky(false);
    }, [topPosition]);

    useEffect(() => {
        checkStickiness();
    }, [checkStickiness]);

    useEffect(() => {
        window.addEventListener('scroll', checkStickiness);
        return () => window.removeEventListener('scroll', checkStickiness);
    }, [checkStickiness]);

    return { stickyElementRef, isSticky };
};
